import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Flex, useTextCounter } from '@ui';
import Search from './Search';

import { attachPropertiesToComponent } from '@ui/utils/attachPropertiesToComponent';

import './index.scss';

const Input = forwardRef((props, ref) => {
  const {
    style,
    className,
    inputClass,
    autoFocus,
    autoComplete = "false",
    maxLength = Infinity,
    disabled,
    prefix,
    suffix,
    showCount,
    defaultValue,
    danger,
    ...resetProps
  } = props;

  const [inputRef, renderTextCounter] = useTextCounter({
    length: props.value?.length || defaultValue?.length || 0,
    disabled: !showCount || disabled,
    maxLength,
  });

  useImperativeHandle(ref, () => ({
    get value() {
      return inputRef.current?.value;
    },
    set value(val) {
      // inputRef.current.value = val;
    },
    focus: options => inputRef.current?.focus(options),
  }));

  useEffect(() => {
    autoFocus && inputRef.current?.focus();
  }, [inputRef.current]);

  return (
    <Flex
      center
      style={style}
      className={[
        'rounded-[6px]',
        'border border-normal',
        { 'hover:border-[#222222] focus-within:border-[#222222]': !disabled },
        {
          'text-[#999] bg-input-disabled border-disabled': disabled,
        },
        {
          'border-danger hover:border-danger focus-within:border-danger':
            danger,
        },
        className,
      ]}
    >
      {prefix}
      <input
        ref={inputRef}
        disabled={disabled}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        maxLength={maxLength}
        defaultValue={defaultValue}
        className={[
          'p-10px',
          'size-full',
          'bg-black bg-opacity-0',
          'placeholder-[rgba(34,34,34,0.5)]',
          inputClass,
        ]}
        {...resetProps}
      />
      {suffix}
      {showCount && renderTextCounter({ className: 'pr-10px' })}
    </Flex>
  );
});

export default attachPropertiesToComponent(Input, { Search });
